import { Navigate, Outlet } from 'react-router'
import { useSesion } from '../auth/useSesion'
import { Cargando } from '../componentes/Cargando'

export function RutaProtegida() {
  const { sesion, cargando } = useSesion()

  // Mientras no se sepa si hay sesion no se puede decidir: redirigir aqui
  // produciria un parpadeo de la pantalla de acceso en cada recarga.
  if (cargando) return <Cargando mensaje="Comprobando la sesion" />
  if (!sesion) return <Navigate to="/login" replace />
  return <Outlet />
}
